import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "text-capitalize-first" }
const _hoisted_3 = { class: "text-danger" }
const _hoisted_4 = { class: "text-capitalize-first" }
const _hoisted_5 = {
  key: 0,
  class: "text-danger text-capitalize-first"
}
const _hoisted_6 = { class: "text-capitalize-first d-inline-block" }
const _hoisted_7 = {
  key: 0,
  class: "text-danger text-capitalize-first d-inline-block"
}
const _hoisted_8 = {
  key: 1,
  class: "text-danger text-capitalize-first d-inline-block"
}
const _hoisted_9 = { class: "d-inline-block ms-2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_copy_button = _resolveComponent("copy-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.helper.trans(`antifraudalerts.rule.${_ctx.alert.rule}`)), 1),
    _createElementVNode("div", _hoisted_3, [
      _cache[0] || (_cache[0] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
      _cache[1] || (_cache[1] = _createTextVNode()),
      _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.helper.trans(`antifraudalerts.description.${_ctx.alert.rule}.default`, {currency: _ctx.data?.currency, sum: _ctx.numberFormatter.formatNumber(_ctx.data?.sum, 2), limit: _ctx.numberFormatter.formatNumber(_ctx.data?.limit, 2), period: parseInt(_ctx.data?.period/60)})), 1)
    ]),
    (_ctx.data?.trafficBlocked)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _cache[2] || (_cache[2] = _createElementVNode("i", { class: "fa fa-warning" }, null, -1)),
          _cache[3] || (_cache[3] = _createTextVNode()),
          _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.helper.trans('labels.traffic_blocked')), 1)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", null, [
      _cache[5] || (_cache[5] = _createElementVNode("i", { class: "fa fa-warning text-danger" }, null, -1)),
      _cache[6] || (_cache[6] = _createTextVNode()),
      (_ctx.data?.disputeOpened)
        ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(_ctx.helper.trans(`antifraudalerts.description.${_ctx.alert.rule}.opened_dispute`)), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_ctx.helper.trans(`antifraudalerts.description.${_ctx.alert.rule}.to_dispute`)), 1)),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.data?.dealsToCheck, (id) => {
        return (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(id), 1),
          _cache[4] || (_cache[4] = _createTextVNode()),
          _createVNode(_component_copy_button, { value: id }, null, 8, ["value"])
        ]))
      }), 256))
    ])
  ]))
}